import { get, unescape } from 'lodash'
import styled, { css } from 'styled-components'

import ImageWithFallback from '@/utilities/client-components/components/Icon/ImageWithFallback'

import { HorizontalAlignmentsPropTypes } from './PropTypes'
import withSpacing from './WithSpacing'

const StyledImageContainer = styled.div`
  display: flex;
  flex: 1;

  ${(props: any) => {
    switch (props.horizontalAlignment) {
      case 'left': {
        return css`
          justify-content: flex-start;
          align-items: flex-start;
        `
      }
      case 'right': {
        return css`
          justify-content: flex-end;
          align-items: flex-end;
        `
      }
      case 'center': {
        return css`
          justify-content: center;
          align-items: center;
        `
      }
      default: {
        return css`
          justify-content: flex-start;
          align-items: flex-start;
        `
      }
    }
  }};
`

const StyledImage = styled(ImageWithFallback)`
  border-radius: ${(props: any) => (props.imageStyle === 'circle' ? '50%' : 0)};

  ${(props: any) => {
    switch (props.size) {
      case 'stretch': {
        return css`
          width: calc(100% + ${(props: any) => props.theme.spacing.padding * 2}px);
          height: calc(100% + ${(props: any) => props.theme.spacing.padding * 2}px);
          margin-right: -${(props: any) => props.theme.spacing.padding}px;
          margin-left: -${(props: any) => props.theme.spacing.padding}px;
        `
      }
      case 'auto': {
        return css`
          width: 100%;
          height: 100%;
        `
      }
      case 'small': {
        return css`
          width: ${(props: any) => get(props.theme, 'containerSizes.small')}px;
          max-height: 100%;
        `
      }
      case 'medium': {
        return css`
          width: ${(props: any) => get(props.theme, 'containerSizes.medium')}px;
          max-height: 100%;
        `
      }
      case 'large': {
        return css`
          width: ${(props: any) => get(props.theme, 'containerSizes.large')}px;
          max-height: 100%;
        `
      }
      default: {
        return css`
          width: 100%;
          height: 100%;
        `
      }
    }
  }};
`

interface ImageProps {
  altText?: string
  horizontalAlignment?: HorizontalAlignmentsPropTypes
  onError?(...args: unknown[]): unknown
  overallFlavor?: string
  size?: 'auto' | 'stretch' | 'small' | 'medium' | 'large'
  style?: 'default' | 'circle' | ''
  url: string
}

const Image = ({ url, altText, horizontalAlignment, size, overallFlavor, style: imageStyle, onError }: ImageProps) => {
  return (
    // @ts-expect-error
    <StyledImageContainer data-item={'wg-image'} horizontalAlignment={horizontalAlignment}>
      <StyledImage
        onError={onError}
        // @ts-expect-error
        size={size}
        overallFlavor={overallFlavor}
        src={unescape(url)}
        alt={unescape(altText)}
        imageStyle={imageStyle}
      />
    </StyledImageContainer>
  )
}

Image.displayName = 'Image'

Image.defaultProps = {
  size: 'auto',
  style: 'default',
  onError: () => {}
}

export default withSpacing(Image)

export { Image } //for testing
